export const tableRangeSettings = {
	drawer: {
		title: "Configurar ambientes",
		saveBtn: "Salvar",
	},
	header: {
		addBtn: "Adicionar ambiente",
		searchPlaceholder: "Buscar por bar",
	},
	card: {
		title: "Ambiente {{from}} a {{to}}",
		subtitle: "Mesas {{from}} a {{to}}",
		barsLabel: "Impressão nos bares",
		deleteBtn: "Excluir ambiente",
		hideBtn: "Esconder",
	},
	list: {
		emptyState: {
			title: "Ainda não tem nada por aqui",
			subtitle: "Você não adicionou ambientes para seu estabelecimento.",
		},
	},
	form: {
		status: {
			errors: {
				description:
					"Não foi possível adicionar o intervalo de mesas informado. Verifique se não há repetição de alguma mesa cuja configuração de impressão já tenha sido feita anteriormente.",
				title: "Algo não saiu como planejado.",
			},
			success: {
				titleEditing: "Edição de intervalo de mesas salva.",
				titleCreating: "Intervalo de mesas configurado com sucesso!",
			},
		},
		generalWrapperLabel: "Intervalo {{number}}",
		intervalWrapperLabel: "Intervalo de mesas",
		bars: {
			label: "Bares que imprimirão pedidos desse ambiente",
			placeholder: "Pesquise por nome",
			selectedBar: "bar selecionado",
			selectedBars_one: "{{count}} bar selecionado",
			selectedBars_other: "{{count}} bares selecionados",
		},
		environmentNameLabel: "Nome do ambiente",
		environmentNamePlaceholder: "Defina um título para esse grupo de mesas",
		removeIntervalBtn: "Remover intervalo",
		editingWarningTooltip: "Não é possível adicionar novos intervalos no modo edição.",
		addIntervalBtn: "Adicionar outro ambiente",
		errors: {
			missingEnvironmentName: "Digite o nome do ambiente (intervalo {{number}})",
			atLeastOneBar: "Selecione pelo menos um bar para impressão (intervalo {{number}})",
			missingFromTable: "Digite o número da mesa inicial (intervalo {{number}})",
			missingToTable: "Digite o número da mesa final (intervalo {{number}})",
			fromTableAlreadyUsed: "Número da mesa inicial já utilizado (intervalo {{number}})",
			toTableAlreadyUsed: "Número da mesa final já utilizado (intervalo {{number}})",
		},
	},
	deleteModal: {
		title: "Deseja excluir esse ambiente?",
		messageLine1:
			"As mesas atribuídas serão também excluídas, mas os dados atrelados a elas serão mantidos em seus relatórios.",
		messageLine2: "Não será possível desfazer essa ação.",
		confirmBtn: "Sim, desejo excluir",
	},
	tabs: {
		generalSettings: "Configurações gerais",
		printByTableSettings: "Configurar impressão por mesa",
	},
};
